// All information general store
let registrationInfo = []
let gst_document = ''
let fssai_document = ''
let aadhar_document = ''
let pan_document = ''
let photo = ''

let gstDocBase64URL = ''
let fssaiDocBase64URL = ''
let aadharDocBase64URL = ''
let panDocBase64URL = ''
let photoDocBase64URL = ''

$(document).on('change', '#gst_document', function(event) {
  gst_document = this.files[0];

  let fileReader = new FileReader()
  fileReader.onload = () => {
    gstDocBase64URL = fileReader.result
  }
  fileReader.readAsDataURL(gst_document)
})

$(document).on('change', '#fssai_document', function(event) {
  fssai_document = this.files[0];

  let fileReader = new FileReader()
  fileReader.onload = () => {
    fssaiDocBase64URL = fileReader.result
  }
  fileReader.readAsDataURL(fssai_document)
})

$(document).on('change', '#pan_document', function(event) {
  pan_document = this.files[0];

  let fileReader = new FileReader()
  fileReader.onload = () => {
    panDocBase64URL = fileReader.result
  }
  fileReader.readAsDataURL(pan_document)
})

$(document).on('change', '#aadhar_document', function(event) {
  aadhar_document = this.files[0];

  let fileReader = new FileReader()
  fileReader.onload = () => {
    aadharDocBase64URL = fileReader.result
  }
  fileReader.readAsDataURL(aadhar_document)
})

$(document).on('change', '#photo', function(event) {
  photo = this.files[0];

  let fileReader = new FileReader()
  fileReader.onload = () => {
    photoDocBase64URL = fileReader.result
  }
  fileReader.readAsDataURL(photo)
})

// fetch and update managers
const regionalManagersURL = 'https://sstb2b.marmeto.com/api/getRegionalManager'
fetch(regionalManagersURL)
  .then(response => response.json())
  .then(data => {
    const allManagers = data.data
    console.log('allManagers', allManagers)
    $('#sales_manager .form-control').empty()
    allManagers.forEach((manager, index) => {
      $('#sales_manager .form-control').append(`<option id="${manager.id}">${manager.name}</option>`)
    })
  })
  .catch(error => {
    console.log('ERROR FETCHING MANAGERS', error);
  })

/*File upload*/
$("form").on("change", ".file-upload-field", function() {
  $(this).parent(".file-upload-wrapper").attr("data-text", $(this).val().replace(/.*(\/|\\)/, ''));

  // upload file size registration form

  var file = $(this).prop("files")[0];
  // console.log(file)
  if (file != undefined) {
    var fsize = file.size;
    var fsize_mb = Math.round((fsize / 1024 / 1024));
    if (fsize_mb > 1) {
      alert("Please select a file less than 1MB");
      $(this).parent(".file-upload-wrapper").attr("data-text", "");
      return false;
    }
    return true;
  }
});

$("form").on("change", ".step1 button.button", function() {
  var file = $(".file-upload-field").prop("files")[0];
  // console.log(file)
  if (file != undefined) {
    var fsize = file.size;
    var fsize_mb = Math.round((fsize / 1024 / 1024));
    if (fsize_mb > 1) {
      alert("Please select a file less than 1MB");
      return false;
    }
    return true;
  }
});

/*Selfie upload*/
$('.file-input').change(function() {
  var curElement = $('.image');
  console.log(curElement);
  var reader = new FileReader();
  reader.onload = function(e) {
    // get loaded data and render thumbnail.
    curElement.attr('src', e.target.result);
  };

  // read the image file as a data URL.
  reader.readAsDataURL(this.files[0]);
  $('.image_icon_first').addClass('d-none');
  $('.file-upload').addClass('selfie-icon');
  $('.file-text').addClass('d-none');
  $('.icon-hide').addClass('d-block');
});

$(window).scroll(function() {
  if ($(window).scrollTop() > 10) {
    $('.header-wrap').addClass('shadow');
  } else {
    $('.header-wrap').removeClass('shadow');
  }
});

/*Step script*/
//DOM elements
const DOMstrings = {
  stepsBtnClass: 'multisteps-form__progress-btn',
  stepsBtns: document.querySelectorAll(`.multisteps-form__progress-btn`),
  stepsBar: document.querySelector('.multisteps-form__progress'),
  stepsForm: document.querySelector('.multisteps-form__form'),
  stepsFormTextareas: document.querySelectorAll('.multisteps-form__textarea'),
  stepFormPanelClass: 'multisteps-form__panel',
  stepFormPanels: document.querySelectorAll('.multisteps-form__panel'),
  stepPrevBtnClass: 'js-btn-prev',
  stepNextBtnClass: 'js-btn-next'
};

//remove class from a set of items
const removeClasses = (elemSet, className) => {
  elemSet.forEach(elem => {
    elem.classList.remove(className);
  });
};

//return exect parent node of the element
const findParent = (elem, parentClass) => {
  let currentNode = elem;
  while (!currentNode.classList.contains(parentClass)) {
    currentNode = currentNode.parentNode;
  }
  return currentNode;
};

//get active button step number
const getActiveStep = elem => {
  return Array.from(DOMstrings.stepsBtns).indexOf(elem);
};

//set all steps before clicked (and clicked too) to active
const setActiveStep = activeStepNum => {

  //remove active state from all the state
  removeClasses(DOMstrings.stepsBtns, 'js-active');

  //set picked items to active
  DOMstrings.stepsBtns.forEach((elem, index) => {
    if (index < activeStepNum) {
      elem.classList.add('js-completed');
    }
    if (index == activeStepNum) {
      elem.classList.add('js-active');
    }
  });
};

//get active panel
const getActivePanel = () => {
  let activePanel;
  DOMstrings.stepFormPanels.forEach(elem => {
    if (elem.classList.contains('js-active')) {
      activePanel = elem;
    }
  });
  return activePanel;
};

//open active panel (and close unactive panels)
const setActivePanel = activePanelNum => {

  //remove active class from all the panels
  removeClasses(DOMstrings.stepFormPanels, 'js-active');

  //show active panel
  DOMstrings.stepFormPanels.forEach((elem, index) => {
    //     alert(index + '----' + activePanelNum);
    if (index === activePanelNum) {
      elem.classList.add('js-active');
      $('.multisteps-form__progress button').each(function() {
      });
      setFormHeight(elem);
    }
  });
};

//set form height equal to current panel height
const formHeight = activePanel => {
  const activePanelHeight = activePanel.offsetHeight;
  DOMstrings.stepsForm.style.height = `auto`;
};

const setFormHeight = () => {
  const activePanel = getActivePanel();
  formHeight(activePanel);
};

//STEPS BAR CLICK FUNCTION
DOMstrings.stepsBar.addEventListener('click', e => {

  //check if click target is a step button
  const eventTarget = e.target;

  if (!eventTarget.classList.contains(`${DOMstrings.stepsBtnClass}`)) {
    return;
  }

  //get active button step number
  const activeStep = getActiveStep(eventTarget);

  //set all steps before clicked (and clicked too) to active
  setActiveStep(activeStep);

  //open active panel
  setActivePanel(activeStep);
});

// hide error when focused on input
$('input').focus(() => {
  $('.empty-field-err').hide()
})

//PREV/NEXT BTNS CLICK
DOMstrings.stepsForm.addEventListener('click', e => {

  const eventTarget = e.target;

  //check if we clicked on `PREV` or NEXT` buttons
  if (!(eventTarget.classList.contains(`${DOMstrings.stepPrevBtnClass}`) || eventTarget.classList.contains(`${DOMstrings.stepNextBtnClass}`))) {
    return;
  }

  ////////////////////////////////////////////////////////////////////////////////

  if ($(eventTarget).attr('id') === 'regd-submit') {

    let firmName = $('#firm_name .form-control').val()
    let city = $('#select_city').find("option:selected").text()
    let state = $('#select_state').find("option:selected").text()
    let country = $('#select_country').find("option:selected").text()
    let pincode = $('#pincode .form-control').val()
    let address = $('#address .form-control').val()
    let GSTNumber = $('#gst_number .form-control').val()
    let GSTDocument = gst_document
    let FSSAINumber = $('#fssai_number .form-control').val()
    let FSSAIDocument = fssai_document



    console.log(firmName, city, state, country, pincode, address, GSTNumber, GSTDocument, FSSAINumber, FSSAIDocument);
    if (!firmName || !city || !state || !country || !pincode || !address || !GSTNumber || !GSTDocument || !FSSAINumber || !FSSAIDocument) {
      $('#regd-submit').parent('.button-row.lp-flex.lp-justify-center').after('<p class="empty-field-err" style="margin-top:10px; color:red; text-align: center"> Please fill all the fields </p>')
      return
    }
    const registrationData = {
      firm_name: firmName,
      city: city,
      state: state,
      country: country,
      pincode: pincode,
      address: address,
      gst_number: GSTNumber,
      gst_file: gstDocBase64URL.split(',')[1],
      gst_file_ext: GSTDocument.type,
      fassi_number: FSSAINumber,
      fassi_file: fssaiDocBase64URL.split(',')[1],
      fassi_file_ext: FSSAIDocument.type
    }
    registrationInfo.push(registrationData)

  }

  if ($(eventTarget).attr('id') === 'shipping-submit') {
    let city = $('#shipping_city').find("option:selected").text()
    let state = $('#shipping_state').find("option:selected").text()
    let country = $('#shipping_country').find("option:selected").text()
    let pincode = $('#shipping_pincode .form-control').val()
    let address = $('#shipping_address .form-control').val()



    console.log(city, state, country, pincode, address);
    if (!city || !state || !country || !pincode || !address) {
      $('#shipping-submit').parents('.button-row.lp-flex.lp-justify-center').after('<p class="empty-field-err" style="margin-top:10px; color:red; text-align: center"> Please fill all the fields </p>')
      return
    }

    const registrationData = {
      city: city,
      state: state,
      country: country,
      pincode: pincode,
      address: address
    }
    registrationInfo.push(registrationData)

  }

  if ($(eventTarget).attr('id') === 'owner-submit') {

    let ownerName = $('#owner_name .form-control').val()
    let ownerPhone = $('#contact_number .form-control').val()
    let ownerEmail = $('#owner_email .form-control').val()
    let ownerType = $('#owner_type').val()
    let aadhar_no = $('#aadhar_number .form-control').val()
    let aadharDocument = aadhar_document
    let aadhar_file_ext = aadhar_document.type
    let pan_no = $('#pan_number .form-control').val()
    let pan_file = pan_document
    let pan_file_ext = pan_document.type
    let ownerPhoto = photo
    let ownerphotoExt = photo.type
    let ipAddress = $('#ip_detection').val()
    let regionalManagerID = $('#sales_manager .form-control').find("option:selected").attr('id')
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!ownerEmail.match(mailformat)) {
      $('div#owner_email .less-email-error').html('Please enter valid Email');
      $('div#owner_email .less-email-error').show();
      return false;

    } else {
      $('div#owner_email .less-email-error').html('');
      $('div#owner_email .less-email-error').hide();
    }
    console.log(ownerName, ownerPhone, ownerEmail, ownerType, aadhar_no, aadharDocument, aadhar_file_ext, pan_no, pan_file, pan_file_ext, ownerPhoto, ownerphotoExt, ipAddress, regionalManagerID);

    if (!ownerName || !ownerPhone || !ownerEmail || !aadhar_no ||
      !aadharDocument || !aadhar_file_ext || !pan_no || !pan_file || !pan_file_ext ||
      !ownerPhoto || !ownerphotoExt || !ipAddress || !regionalManagerID) {
      $('#owner-submit').parents('.button-row.lp-flex.lp-justify-center').after('<p class="empty-field-err" style="margin-top:10px; color:red; text-align: center"> Please fill all the fields </p>')
      return
    }

    const registrationData = {
      name: ownerName,
      phone: ownerPhone,
      email: ownerEmail,
      owner_type: ownerType,
      aadhar_no: aadhar_no,
      aadhar_file: aadharDocBase64URL.split(',')[1],
      aadhar_file_ext: aadhar_file_ext,
      pan_no: pan_no,
      pan_file: panDocBase64URL.split(',')[1],
      pan_file_ext: pan_file_ext,
      owner_file: photoDocBase64URL.split(',')[1],
      owner_file_ext: ownerphotoExt,
      ip_address: ipAddress,
      regional_manager_id: regionalManagerID
    }
    registrationInfo.push(registrationData)

    const postRegdDataURL = 'https://sstb2b.marmeto.com/api/registerCustomer'
    const regdData = {
      firm_details: registrationInfo[0],
      shipping_address: registrationInfo[1],
      firm_owner_details: registrationInfo[2]
    }
    console.log('regdData', regdData)
    fetch(postRegdDataURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(regdData),
    }).then((response) => {
      if(response.status == 200){
        console.log('Registration information sent successfully', response);
      setPanel(eventTarget);
      } else {
        handleError(response);
        console.log('Registration information sending failed!', response);
      } 
    }).catch(error => {
      handleError(response);
      console.log('Registration information sending failed!');
    })
    return;
  }
  setPanel(eventTarget);
  console.log('registrationInfo', registrationInfo);
});

function setPanel(eventTarget) {
  //find active panel
  const activePanel = findParent(eventTarget, `${DOMstrings.stepFormPanelClass}`);
  let activePanelNum = Array.from(DOMstrings.stepFormPanels).indexOf(activePanel);

  //set active step and active panel onclick
  if (eventTarget.classList.contains(`${DOMstrings.stepPrevBtnClass}`)) {
    activePanelNum--;
  } else {
    activePanelNum++;
  }
  setActiveStep(activePanelNum);
  setActivePanel(activePanelNum);
}
function handleError(response) {
  if(response.status != 200){
    alert(response.statusText);
  } 
}



//SETTING PROPER FORM HEIGHT ONLOAD
window.addEventListener('load', setFormHeight, false);

//SETTING PROPER FORM HEIGHT ONRESIZE
window.addEventListener('resize', setFormHeight, false);

//changing animation via animation select !!!YOU DON'T NEED THIS CODE (if you want to change animation type, just change form panels data-attr)

const setAnimationType = newType => {
  DOMstrings.stepFormPanels.forEach(elem => {
    elem.dataset.animation = newType;
  });
};

//selector onchange - changing animation
const animationSelect = document.querySelector('.pick-animation__select');

if (animationSelect != null) {
  animationSelect.addEventListener('change', () => {
    const newAnimationType = animationSelect.value;
    setAnimationType(newAnimationType);
  });
}

$(".num_only").bind("keypress", function(e) {
  var keyCode = e.which ? e.which : e.keyCode;
  if (!((keyCode >= 48 && keyCode <= 57))) {
    return false;
  }
});